import React from "react";
import { Link } from "react-router-dom";
import { SiTiktok } from "react-icons/si";
import CoinMarketCap from "../assets/images/icons/Coinmarketcap.svg";
import Medium from "../assets/images/icons/Medium.png";
import { BRAND } from "../config/brand";
import { useTheme } from "../context/ThemeContext";

function Footer() {
  const { theme } = useTheme();
  const logoSrc = theme === "light" ? BRAND.logoPathLight : BRAND.logoPath;

  return (
    <>
      <div className="footer">
        <div className="footer-bg-word" aria-hidden="true">
          {BRAND.tokenSymbol}
        </div>
        <div className="logo-section">
          <div className="foot-logo">
            <img src={logoSrc} alt={`${BRAND.name} logo`} width={35} />
            <p>{BRAND.name}</p>
          </div>
          <p className="footer-para">
            A stable and transparent digital <br /> BSC Smart Chain Powered Blockchain
          </p>
          <div className="footer-badges">
            <div className="footer-bsc-badge">
              <img src="/images/bnb.svg" alt="" width={18} height={18} aria-hidden="true" />
              <span>Powered by Binance Smart Chain</span>
            </div>
          </div>
          <div className="footer-socials">
            <h3>Our Socials</h3>
            <div className="social-icons-row">
              <Link
                to={BRAND.socialLinks.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-btn"
                aria-label="Instagram"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.6675 7C9.0101 7 7.66748 8.3431 7.66748 10C7.66748 11.6573 9.0106 13 10.6675 13C12.3248 13 13.6675 11.6569 13.6675 10C13.6675 8.3427 12.3244 7 10.6675 7ZM10.6675 5C13.4279 5 15.6675 7.2371 15.6675 10C15.6675 12.7605 13.4304 15 10.6675 15C7.90701 15 5.66748 12.7629 5.66748 10C5.66748 7.23953 7.90458 5 10.6675 5ZM17.1675 4.74915C17.1675 5.43926 16.6067 5.99917 15.9175 5.99917C15.2274 5.99917 14.6675 5.4384 14.6675 4.74915C14.6675 4.0599 15.2282 3.5 15.9175 3.5C16.6058 3.49913 17.1675 4.0599 17.1675 4.74915ZM10.6675 2C8.193 2 7.78968 2.00655 6.63877 2.0578C5.85465 2.09461 5.32903 2.20007 4.84066 2.38967C4.40666 2.55799 4.09359 2.75898 3.76002 3.09255C3.42517 3.4274 3.22454 3.73963 3.0569 4.17383C2.86686 4.66332 2.76143 5.18811 2.72528 5.97115C2.67353 7.0752 2.66748 7.46105 2.66748 10C2.66748 12.4745 2.67403 12.8778 2.72527 14.0286C2.7621 14.8124 2.8677 15.3388 3.05684 15.826C3.2256 16.2606 3.427 16.5744 3.75896 16.9064C4.09513 17.2421 4.40829 17.4434 4.83837 17.6094C5.33269 17.8005 5.85798 17.9061 6.63862 17.9422C7.74268 17.9939 8.12853 18 10.6675 18C13.142 18 13.5453 17.9934 14.6961 17.9422C15.4782 17.9055 16.005 17.7996 16.4935 17.6106C16.9269 17.4423 17.2417 17.2402 17.5739 16.9085C17.9101 16.5718 18.111 16.2594 18.2772 15.8283C18.4678 15.3358 18.5736 14.8098 18.6097 14.0289C18.6614 12.9248 18.6675 12.5389 18.6675 10C18.6675 7.52552 18.6609 7.12221 18.6097 5.97137C18.5729 5.18906 18.467 4.66149 18.2778 4.17318C18.1099 3.74038 17.9082 3.42635 17.5749 3.09255C17.2395 2.75715 16.9281 2.55693 16.4936 2.38942C16.0045 2.19954 15.4789 2.09396 14.6963 2.05781C13.5923 2.00605 13.2064 2 10.6675 2ZM10.6675 0C13.3841 0 13.7233 0.00999994 14.79 0.0599999C15.8541 0.10917 16.58 0.2775 17.2175 0.525C17.8766 0.77917 18.4333 1.1225 18.9891 1.67833C19.5441 2.23417 19.8875 2.7925 20.1425 3.45C20.3891 4.08667 20.5575 4.81333 20.6075 5.8775C20.655 6.94417 20.6675 7.28333 20.6675 10C20.6675 12.7167 20.6575 13.0558 20.6075 14.1225C20.5583 15.1867 20.3891 15.9125 20.1425 16.55C19.8883 17.2092 19.5441 17.7658 18.9891 18.3217C18.4333 18.8767 17.8741 19.22 17.2175 19.475C16.58 19.7217 15.8541 19.89 14.79 19.94C13.7233 19.9875 13.3841 20 10.6675 20C7.95081 20 7.61164 19.99 6.54498 19.94C5.48081 19.8908 4.75581 19.7217 4.11748 19.475C3.45914 19.2208 2.90164 18.8767 2.34581 18.3217C1.78998 17.7658 1.44748 17.2067 1.19248 16.55C0.944981 15.9125 0.777481 15.1867 0.727481 14.1225C0.679981 13.0558 0.66748 12.7167 0.66748 10C0.66748 7.28333 0.677481 6.94417 0.727481 5.8775C0.776641 4.8125 0.944981 4.0875 1.19248 3.45C1.44664 2.79167 1.78998 2.23417 2.34581 1.67833C2.90164 1.1225 3.45998 0.78 4.11748 0.525C4.75498 0.2775 5.47998 0.11 6.54498 0.0599999C7.61164 0.0124999 7.95081 0 10.6675 0Z"
                    fill="currentColor"
                  />
                </svg>
              </Link>

              <Link
                to={BRAND.socialLinks.x}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-btn"
                aria-label="Twitter / X"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.3539 3.0625L13.3572 8.77425L9.03695 3.0625H2.77979L10.2561 12.8387L3.17028 20.9375H6.20446L11.6733 14.6886L16.4528 20.9375H22.555L14.7615 10.6342L21.3863 3.0625H18.3539ZM17.2897 19.1225L6.32086 4.78217H8.12395L18.9699 19.1225H17.2897Z"
                    fill="currentColor"
                  />
                </svg>
              </Link>

              {/* <Link
                to={BRAND.socialLinks.coinMarketCap}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-btn"
                aria-label="CoinMarketCap"
              >
                <img src={CoinMarketCap} alt="" aria-hidden="true" />
              </Link> */}

              <Link
                to={BRAND.socialLinks.discord}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-btn"
                aria-label="Discord"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.18713 13.8456C8.1471 13.8456 7.2981 12.9012 7.2981 11.7444C7.2981 10.5877 8.12587 9.64307 9.18713 9.64307C10.2377 9.64307 11.0973 10.5877 11.0761 11.7444C11.0761 12.9012 10.2377 13.8456 9.18713 13.8456ZM16.1606 13.8456C15.1205 13.8456 14.2705 12.9012 14.2705 11.7444C14.2705 10.5877 15.0993 9.64307 16.1606 9.64307C17.2112 9.64307 18.0708 10.5877 18.0496 11.7444C18.0496 12.9012 17.2218 13.8456 16.1606 13.8456ZM10.7918 4.32272L10.4831 3.75977L9.84974 3.86532C8.38566 4.10934 6.99309 4.54653 5.69195 5.1458L5.46302 5.25124L5.32158 5.45985C2.70831 9.31417 1.99231 13.1085 2.34683 16.836L2.38548 17.2423L2.71563 17.4822C4.45502 18.7463 6.14068 19.5187 7.79378 20.0255L8.58308 20.2674L9.69664 17.5504C11.6062 18.0224 13.7257 18.0226 15.6355 17.5509L16.7422 20.2681L17.5333 20.0254C19.1838 19.5191 20.8802 18.747 22.6131 17.4809L22.9391 17.2428L22.9796 16.8412C23.4156 12.5211 22.2825 8.75749 20.0212 5.45628L19.8793 5.2492L19.6511 5.1448C18.3432 4.54661 16.9517 4.10957 15.4974 3.86549L14.8797 3.76183L14.5652 4.30345C14.4777 4.45421 14.388 4.6244 14.3029 4.79663C13.2106 4.68446 12.1225 4.68422 11.0391 4.79628C10.9547 4.62712 10.869 4.46356 10.7918 4.32272ZM7.38087 16.61C7.57886 16.7241 7.78624 16.8356 7.99208 16.9379L7.54291 18.0338C6.42236 17.6257 5.28488 17.0635 4.11411 16.2555C3.88964 13.1176 4.52743 9.95076 6.67847 6.68602C7.57613 6.29099 8.52001 5.98255 9.50257 5.77271C9.56282 5.89807 9.61886 6.02042 9.6649 6.12893L9.93779 6.77214L10.6291 6.67074C11.9817 6.47236 13.3437 6.4721 14.7188 6.671L15.4089 6.77082L15.6812 6.12893C15.7286 6.01719 15.7832 5.89523 15.8408 5.77298C16.819 5.98302 17.7645 6.29188 18.6694 6.68788C20.5446 9.50833 21.4906 12.6542 21.2151 16.255C20.0502 17.0623 18.9087 17.6247 17.7858 18.0333L17.34 16.9388C17.5464 16.8363 17.7544 16.7244 17.953 16.61C18.4428 16.3278 18.9704 15.9758 19.3067 15.6395L18.0271 14.36C17.8634 14.5237 17.5035 14.7806 17.0496 15.0421C16.6053 15.2981 16.1645 15.505 15.8829 15.5981C13.8791 16.2606 11.4548 16.2606 9.45094 15.5981C9.16936 15.505 8.72856 15.2981 8.28423 15.0421C7.83034 14.7806 7.47043 14.5237 7.30668 14.36L6.02716 15.6395C6.36341 15.9758 6.89101 16.3278 7.38087 16.61Z"
                    fill="currentColor"
                  />
                </svg>
              </Link>

              {/* <Link
                to={BRAND.socialLinks.medium}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-btn"
                aria-label="Medium"
              >
                <img src={Medium} alt="" aria-hidden="true" />
              </Link> */}

              <Link
                to={BRAND.socialLinks.telegram}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-btn"
                aria-label="Telegram"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.7608 7.14594C18.3539 6.93074 18.6483 6.85329 18.8114 6.82559C18.8126 6.87774 18.8114 6.92002 18.8087 6.94776C18.5761 9.39168 17.5571 15.4043 17.0337 18.2021C16.9112 18.8573 16.8172 19.1692 16.1844 18.7975C15.7679 18.5527 15.391 18.2447 14.9872 17.98C13.6626 17.1116 11.7665 15.8184 11.9222 15.8962C10.6181 15.0368 11.164 14.5106 11.892 13.8088C12.0099 13.6952 12.1325 13.577 12.2528 13.452C12.3065 13.3962 12.5692 13.1519 12.9396 12.8076C14.1277 11.703 16.4236 9.56854 16.4816 9.32153C16.4911 9.28101 16.4999 9.12996 16.4101 9.05019C16.3204 8.97043 16.188 8.99771 16.0924 9.0194C15.9569 9.05015 13.7991 10.4764 9.61893 13.2981C9.00644 13.7187 8.45167 13.9237 7.95461 13.9129L7.95906 13.9151C7.30431 13.6842 6.6514 13.4854 5.99505 13.2855C5.56386 13.1541 5.13119 13.0223 4.69554 12.8807C4.58899 12.8461 4.48503 12.8132 4.38733 12.7825C8.91431 10.8104 11.9295 9.51194 13.4404 8.88351C15.6349 7.97075 16.9366 7.44502 17.7608 7.14594ZM20.1834 5.21757C19.93 5.01195 19.6515 4.91758 19.458 4.87136C19.2582 4.82363 19.0683 4.80827 18.9243 4.81081C18.4479 4.8192 17.9362 4.95469 17.0786 5.26588C16.2038 5.58333 14.8595 6.12714 12.6723 7.03687C11.1303 7.67825 8.06038 9.00066 3.47015 11.0005C3.06696 11.1617 2.69736 11.3446 2.40534 11.5614C2.13569 11.7617 1.75823 12.12 1.68918 12.6709C1.63702 13.0869 1.75832 13.4709 2.00432 13.7733C2.21848 14.0365 2.49285 14.1964 2.70179 14.2976C3.01195 14.4478 3.42926 14.5786 3.79602 14.6936C4.36914 14.8732 4.94094 15.0567 5.51529 15.2325C7.29341 15.7768 8.75716 16.2248 10.3677 17.2861C11.549 18.0646 12.7075 18.877 13.8908 19.6526C14.3224 19.9355 14.7258 20.2602 15.1714 20.5219C15.6581 20.8079 16.2769 21.0687 17.0301 20.9993C18.1684 20.8946 18.7606 19.8474 18.9996 18.5698C19.5217 15.7791 20.5574 9.68302 20.7997 7.13725C20.8313 6.80495 20.7943 6.43251 20.7635 6.25269C20.7318 6.06751 20.6349 5.58399 20.1834 5.21757Z"
                    fill="currentColor"
                  />
                </svg>
              </Link>

              <Link
                to={BRAND.socialLinks.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-btn"
                aria-label="TikTok"
              >
                <SiTiktok size={16} />
              </Link>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col ">
            <h3 className="gap">Company</h3>
            <p>
              <Link to="/#hero">Presale</Link>
            </p>
            <p>
              <Link to="/#about">About 1EYE</Link>
            </p>
            <p>
              <Link to="/#tokenomics">Tokenomics</Link>
            </p>
            <p>
              <Link to="/contactus">Contact Us</Link>
            </p>
          </div>
          <div className="col ">
            <h3 className="gap">More</h3>
            <p>
              <Link to={BRAND.auditUrl}>Audit Report</Link>
            </p>
            <p>
              <Link to={BRAND.whitepaperUrl} target="_blank" rel="noopener noreferrer">
                Whitepaper
              </Link>
            </p>
            <p>
              <Link to="/privacy">Privacy Policy</Link>
            </p>
            <p>
              <Link to="/terms">Terms of Services</Link>
            </p>
          </div>
        </div>
      </div>
      <div className="line">
        <hr />
      </div>
      <div className="last-footer">
        <p>© {new Date().getFullYear()} {BRAND.name}. All Rights Reserved</p>
      </div>
    </>
  );
}

export default Footer;
